import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import {
  EventInformation,
  IraceEvents,
  Navbar,
  Page404,
  PaymentFinish,
} from '.';
import classes from './style';
import { CssBaseline, useMediaQuery } from '@mui/material';
import ReactGA from 'react-ga4';
// import { generate } from '../utils/generateToken';
import IndomaretRegistration from './indomaret/RegistrationIndomaret';
import SummaryIndomaretRegistartion from './indomaret/SummaryIndomaretRegistration';
import { generate } from '../utils/generateToken';
import PengaduanKupon from './indomaret/PengaduanKupon';
import PengaduanListPage from './indomaret/PengaduanListPage';

// ZXlKcFpDSTZOemtzSW5SNWNHVWlPaUpQUmtaTVNVNUZJbjA9K2lyYWNlMjAyMA== 79
// ZXlKcFpDSTZPREFzSW5SNWNHVWlPaUpQUmtaTVNVNUZJbjA9K2lyYWNlMjAyMA== 80

const App = () => {
  // console.log(
  //   'irace event ',
  //   generate(JSON.stringify({ id: 81, type: 'OFFLINE' }))
  // );
  const isMobile = useMediaQuery('(max-width: 600px)');
  // console.log('generateToken : ', generate(59));
  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GA4_ID);
    // Send pageview with a custom path
  }, []);

  return (
    <div style={classes.root}>
      <CssBaseline />
      <Navbar />
      <main style={isMobile ? classes.contentMobile : classes.content}>
        <div style={classes.toolbar} />
        <Routes>
          <Route path="*" element={<Page404 />} />
          <Route exact path="/payment/finish" element={<PaymentFinish />} />
          <Route exact path="/event/:item" element={<EventInformation />} />
          <Route
            exact
            path="/event/register/:item"
            element={<IndomaretRegistration />}
          />
          <Route
            exact
            path="/event/register/indomaret/summary"
            element={<SummaryIndomaretRegistartion />}
          />
          <Route
            exact
            path="/event/indomaret/pengaduan"
            element={<PengaduanKupon />}
          />
          <Route
            exact
            path="/event/indomaret/pengaduan/list"
            element={<PengaduanListPage />}
          />
          <Route exact path="/" element={<IraceEvents />} />
        </Routes>
        {/* <RegistrationIndomaret /> */}
      </main>
    </div>
  );
};

export default App;
